

































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class LeaseOperatorFreeModal extends Vue {
  @Prop() basicDetailData!: any;
  @Prop() showModal = false;
  @Prop() onHideModal!: Function;
  @Prop() onSubmitModal!: Function;
}
